import {
    AlertTriangle,
    Trash2,
    Info,
    CheckCircle
} from "lucide-react";

import Button from "./Button";

import "./ConfirmDialog.css";

export default function ConfirmDialog({

    open,

    variant = "danger",

    title = "Confirm",

    message,

    confirmText = "Confirm",

    cancelText = "Cancel",

    loading = false,

    onConfirm,

    onCancel

}){

    if(!open){

        return null;

    }

    const icons = {

        danger:<Trash2 size={24}/>,

        warning:<AlertTriangle size={24}/>,

        success:<CheckCircle size={24}/>,

        info:<Info size={24}/>

    };

    return(

        <div

            className="confirm-overlay"

            onClick={onCancel}

        >

            <div

                className="confirm-dialog"

                onClick={e=>e.stopPropagation()}

            >

                <div className="confirm-header">

                    <div className={`confirm-icon ${variant}`}>

                        {

                            icons[variant] ||

                            icons.info

                        }

                    </div>

                    <div>

                        <h2>

                            {title}

                        </h2>

                    </div>

                </div>

                <div className="confirm-body">

                    {message}

                </div>

                <div className="confirm-footer">

                    <Button

                        variant="secondary"

                        onClick={onCancel}

                        disabled={loading}

                    >

                        {cancelText}

                    </Button>

                    <Button

                        variant={

                            variant === "danger"

                            ?

                            "danger"

                            :

                            "primary"

                        }

                        loading={loading}

                        onClick={onConfirm}

                    >

                        {confirmText}

                    </Button>

                </div>

            </div>

        </div>

    );

}